// extracted by mini-css-extract-plugin
export default {"scrolls":"style_scrolls__0Bs3Y"};